import React from 'react';

// Dismissible "new card collected" banner. `onDismiss(item)` removes one line.
export default function CollectionBanner({ collections, onDismiss }) {
  if (!collections || collections.length === 0) return null;

  const fmtName = (name) => {
    if (!name) return 'A client';
    if (name.includes(',')) {
      const [last, first] = name.split(',').map((s) => s.trim());
      return `${first} ${last}`;
    }
    return name;
  };

  return (
    <div style={{ marginBottom: 20 }}>
      {collections.map((c) => (
        <div
          key={`${c.linkType}-${c.tokenId}`}
          style={{
            display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
            background: 'linear-gradient(135deg, #1D2C5F 0%, #2F6E6A 100%)',
            color: '#fff', borderRadius: 14, padding: '14px 20px', marginBottom: 10,
            boxShadow: '0 6px 20px rgba(29,44,95,0.22)',
          }}
        >
          <div style={{ flex: 1, minWidth: 220, fontSize: 15, fontWeight: 600 }}>
            💳 <strong>{fmtName(c.clientName)}</strong> {c.typeLabel}
          </div>
          <button
            onClick={() => onDismiss(c)}
            style={{
              background: 'transparent', color: 'rgba(255,255,255,0.9)',
              border: '1px solid rgba(255,255,255,0.55)', borderRadius: 8,
              padding: '8px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap',
            }}
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
